import { Card, Typography } from "@mui/material";
import { funcFormatCurrency, money } from "functions/funcFormatCurrency";
import { KanbanItem } from "modules/revenuePlan";
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { KanbanVertical } from ".";
import { KanbanProvider } from "./kanban-context";

const Kanban = ({
	data: initData,
	children,
	showMoney = true,
	className = "",
}) => {
	const [data, setData] = useState([]);
	useEffect(() => {
		setData(initData);
	}, [initData]);
	const handleDeleteKanban = id => () => {
		const cloneData = [...data];
		cloneData.forEach(val => {
			val.tasks = val.tasks.filter(task => task.id !== id);
		});
		setData(cloneData);
	};
	const handleChangeStatusRevenue = (id, value) => {
		const cloneData = [...data];
		cloneData.forEach(val => {
			val.tasks = val.tasks.map(item =>
				item.id == id ? { ...item, statusRevenue: value } : item
			);
		});
		console.log(
			"🚀 ~ file: Kanban.jsx ~ line 28 ~ handleChangeStatusRevenue ~ cloneData",
			cloneData
		);
	};
	const onDragEnd = ({ source, destination }) => {
		if (!destination) return;
		const sourceColIndex = data.findIndex(e => e.id === source.droppableId);
		const destinationColIndex = data.findIndex(
			e => e.id === destination.droppableId
		);
		const sourceCol = data[sourceColIndex];
		const destinationCol = data[destinationColIndex];
		const sourceSectionId = sourceCol.id;
		const destinationSectionId = destinationCol.id;
		const sourceTasks = [...sourceCol.tasks];
		const destinationTasks = [...destinationCol.tasks];
		if (source.droppableId !== destination.droppableId) {
			const [removed] = sourceTasks.splice(source.index, 1);
			destinationTasks.splice(destination.index, 0, removed);
			data[sourceColIndex].tasks = sourceTasks;
			data[destinationColIndex].tasks = destinationTasks;
		} else {
			const [removed] = destinationTasks.splice(source.index, 1);
			destinationTasks.splice(destination.index, 0, removed);
			data[destinationColIndex].tasks = destinationTasks;
		}
	};
	return (
		<DragDropContext onDragEnd={onDragEnd}>
			<div className={`flex overflow-auto gap-x-30px ${className}`}>
				{data &&
					data.map((item, index) => (
						<Droppable key={item.id} droppableId={item.id}>
							{(provided, snapshot) => (
								<div
									className='kanban-box-list'
									ref={provided.innerRef}
									{...provided.droppableProps}>
									<div className='box-kanban-title flex items-center justify-between text-white h-45px px-15px text-15px bg-blue'>
										<strong className='uppercase'>
											{item.name}
											{` (${item.tasks.length})`}
										</strong>
										{showMoney && (
											<span className='font-semibold'>
												{item.tasks &&
													item.tasks.length > 0 &&
													funcFormatCurrency(
														item.tasks.reduce(
															(acc = 0, val) => {
																return (acc =
																	Number(
																		acc
																	) +
																	Number(
																		val.money
																	));
															},
															[]
														)
													)}
											</span>
										)}
									</div>
									<div
										className='kanban-box-task flex-1 flex flex-col bg-gray-s3 border border-[#DDDDDD] px-6px pt-5px pb-10px max-h-658px h-full transition-all'
										style={{
											backgroundColor:
												snapshot.isDraggingOver
													? "#e4e4e4"
													: "",
										}}>
										<div className='list overflow-auto max-h-658px pr-5px'>
											{item.tasks &&
												item.tasks.map(
													(task, index) => (
														<Draggable
															key={task.id}
															draggableId={
																task.id
															}
															index={index}>
															{(
																provided,
																snapshot
															) => {
																const style = {
																	backgroundColor:
																		snapshot.isDragging
																			? "rgb(255 250 230)"
																			: "white",
																	boxShadow:
																		snapshot.isDragging
																			? "rgb(165 173 186) 2px 2px 1px"
																			: "",
																	border: snapshot.isDragging
																		? "2px solid rgba(9,30,66,0.71)"
																		: "",
																	...provided
																		.draggableProps
																		.style,
																};
																return (
																	<KanbanProvider
																		innerRef={
																			provided.innerRef
																		}
																		provided={
																			provided
																		}
																		data={
																			task
																		}
																		handleChangeStatusRevenue={
																			handleChangeStatusRevenue
																		}
																		setData={
																			setData
																		}
																		style={
																			style
																		}
																		handleDeleteKanban={
																			handleDeleteKanban
																		}>
																		{
																			children
																		}
																	</KanbanProvider>
																);
															}}
														</Draggable>
													)
												)}
										</div>
									</div>
									{provided.placeholder}
								</div>
							)}
						</Droppable>
					))}
			</div>
		</DragDropContext>
	);
};

export default Kanban;
